import { Component, OnInit } from '@angular/core';
import { notificationService } from '../../../service/notification.service';

import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-unotification',
  templateUrl: './unotification.component.html',
  styleUrls: ['./unotification.component.css']
  , providers: [notificationService]
})
export class UnotificationComponent implements OnInit {
  notification: any;
  msg = "";
  constructor(private notificationObj: notificationService) { }

  ngOnInit() {
    this.getnotification();
  }

  getnotification() {
    var obj = {}
    obj['limit'] = 1;
    obj['orderby'] = "id";
    obj['ordertype'] = "desc";
    this.notificationObj.getnotification(obj).subscribe((data:any)=>{
     if(data.error==0){
      this.notification=data.data;

     }
    },(error : HttpErrorResponse)=>{      
      this.msg="internal server error!";
    });

  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/uprofile/unotification/unotification.component.ts